<template>
    <div class="pr-team4-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                    Marketing Services in partnership with Team 4 Marketing
                </div>
                <div class="logo">
                    <img src="/images/team-4-marketing-logo.png">
                </div>
            </div>
            <div class="box-1">
                <h1>Team 4 Marketing – a team focused on you.</h1>
                <p>
                    Got a project story you want to promote in the trade/commercial or retail press – or need some copy
                    for your brochures or website that communicates the value of what your business has to offer?
                </p>
                <p>
                    Our PR partner Team 4 Marketing is here to help.
                </p>
                <p>
                    <a href="https://www.team4marketing.com/" target="_blank" class="btn-primary _lg" @click="partnerLinkClicked()">
                        <strong>Visit Team 4 Marketing</strong>
                    </a>
                </p>
            </div>
            <div class="overlapping-image">
                <youtube-embed videoId="QRRjRngDVYA"></youtube-embed>
            </div>
            <div class="box-2">
                <p>
                    <a class="btn-primary-outline _lg" @click.stop="enquiry_box_open = true">
                        Make Enquiry
                    </a>
                </p>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Team4 Marketing Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        'logged_in_user': {
            required: true,
        },
    },
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I am interested in working on a Marketing project with Team4',
          sending: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 11,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Team 4 Marketing enquiry',
                'value': 'Team 4 Marketing enquiry',
              });

                this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
      partnerLinkClicked() {
        axios.post('/activity-logs/createActivityLogFromRequest', {
          'activity_log_category_id': 3,
          'description': `Partner Link Clicked - Team 4 Marketing`,
        });
        gtag('event', 'partner_link_clicked', {
          'event_category': 'link',
          'event_label': 'Team 4 marketing partner link clicked',
          'value': 'Team 4 marketing partner link clicked',
        });
      },
    },
};
</script>
